import { render, staticRenderFns } from "./ViewInicialPdi.vue?vue&type=template&id=45f5de5c&scoped=true"
import script from "./ViewInicialPdi.vue?vue&type=script&lang=js"
export * from "./ViewInicialPdi.vue?vue&type=script&lang=js"
import style0 from "./ViewInicialPdi.vue?vue&type=style&index=0&id=45f5de5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45f5de5c",
  null
  
)

export default component.exports